import router from './router';
import axios from 'axios'
import {apis} from './core/apis';
import * as appUtils from './core/appUtils';
import NProgress from 'nprogress' // progress bar
import {ConstStatic} from './core/constStatic'
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['timeout'];
const defaultRoutePath = '/home';
const timeOutPath = '/timeout';

router.beforeEach((to, from, next) => {
    NProgress.start() // start progress bar
    let jti = to.query.jti || '';
    let researchId = to.query.researchId || '';
    if (jti && researchId) {
        appUtils.setLocalStorage(ConstStatic.JTI, jti);
        appUtils.setLocalStorage(ConstStatic.RESEARCHID, researchId);
        //此处需要换成广州传过来的参数，来换用户信息以及角色。
        axios({ //换用户信息
            method: 'get',
            url: apis.api.system.checkToken + jti //动态获取
        }).then((res) => {
            if (res.data.status == 0) {
                appUtils.setLocalStorage(ConstStatic.TOKEN_KEY, res.data.access_token);
                appUtils.setLocalStorage(ConstStatic.USER_INFO, res.data.data);
                next();
            } else if (res.data.status == 1001) {
                notification.error({
                    message: '错误',
                    description: '登录超时，重新登录'
                })
                appUtils.removeLocalStorage(ConstStatic.TOKEN_KEY);
                next({path: timeOutPath})
            }
        }).catch((err) => {
            notification.error({
                message: '错误',
                description: '登录超时，重新登录'
            })
            appUtils.removeLocalStorage(ConstStatic.TOKEN_KEY);
            next({path: timeOutPath})
        });
    } else {
        if (appUtils.getToken()) {
            /* has token */
            if (to.path === '/login') {
                next({path: defaultRoutePath})
                NProgress.done()
            } else {
                next();
                NProgress.done()
            }
        } else {
            if (whiteList.includes(to.name)) {
                next()
                // 在免登录白名单，直接进入
                NProgress.done()
            } else {
                next({path: timeOutPath, query: {redirect: to.fullPath}})
                NProgress.done()
            }
        }
    }
})
router.afterEach(() => {
    NProgress.done() // finish progress bar
})